"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Routes = void 0;
var SERVICE_PREFIX = '/analytics-service/v1/capacity-planning';
exports.Routes = {
    GET_RESOURCE_UTILIZATION: "".concat(SERVICE_PREFIX, "/resource-utilization")
};
//# sourceMappingURL=resource-utilization.consts.js.map